module.exports = __webpack_public_path__ + "img/mastercard.73bde687.png";